import React from "react";

export const normalizeAdditionalSchemas = (schemas) =>
  Array.isArray(schemas)
    ? schemas.map((item) => ({
        label: item?.label || "",
        schema: item?.schema || "",
      }))
    : [];

export const validateOptionalSchemas = (seoData) => {
  const schemas = [
    { label: "FAQ Schema", schema: seoData.faq_schema },
    { label: "Article Schema", schema: seoData.article_schema },
    ...normalizeAdditionalSchemas(seoData.additional_schemas),
  ];

  schemas.forEach((item) => {
    if (item.schema?.trim()) {
      JSON.parse(item.schema);
    }
  });
};

export default function AdditionalSchemas({ value = [], onChange }) {
  const schemas = normalizeAdditionalSchemas(value);
  const update = (index, field, fieldValue) => {
    onChange(
      schemas.map((item, itemIndex) =>
        itemIndex === index ? { ...item, [field]: fieldValue } : item
      )
    );
  };

  return (
    <>
      {schemas.map((item, index) => (
        <div className="add-content-wrap" key={index}>
          <div className="row">
            <div className="col-lg-12">
              <div className="add-page-inputs">
                <div className="label-wrap-add">
                  <label>Schema Label</label>
                </div>
                <input
                  type="text"
                  value={item.label}
                  onChange={(event) => update(index, "label", event.target.value)}
                  className="form-control"
                  placeholder="Example: Breadcrumb Schema"
                />
              </div>
            </div>
            <div className="col-lg-12">
              <div className="add-page-inputs">
                <div className="label-wrap-add">
                  <label>Additional Schema</label>
                </div>
                <textarea
                  value={item.schema}
                  onChange={(event) => update(index, "schema", event.target.value)}
                  className="form-control"
                  rows="5"
                  style={{ height: "auto" }}
                  placeholder={'{"@context":"https://schema.org","@type":"BreadcrumbList"}'}
                />
              </div>
            </div>
            <div className="col-lg-12">
              <button
                type="button"
                className="btn btn-danger btn-sm"
                onClick={() => onChange(schemas.filter((_, itemIndex) => itemIndex !== index))}
              >
                Remove Schema
              </button>
            </div>
          </div>
        </div>
      ))}
      <button
        type="button"
        className="addmore-images-client w-100 mb-4"
        onClick={() => onChange([...schemas, { label: "", schema: "" }])}
      >
        Add Schema <span></span>
      </button>
    </>
  );
}
